export default __webpack_public_path__ + "svg/CompaniesLogos/Nodeom.jpg?b3b2a42d";